import { render } from "./rule-msg-box.vue?vue&type=template&id=ff766c0a&scoped=true&ts=true"
import script from "./rule-msg-box.vue?vue&type=script&lang=ts"
export * from "./rule-msg-box.vue?vue&type=script&lang=ts"

import "./rule-msg-box.vue?vue&type=style&index=0&id=ff766c0a&lang=scss&scoped=true"
import "./rule-msg-box.vue?vue&type=style&index=1&id=ff766c0a&lang=scss"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff766c0a"]])

export default __exports__